const COLLAPSED_LINES = 2;
let resizeListenerBound = false;

const debounce = (fn, wait = 150) => {
  let timeout;
  return (...args) => {
    window.clearTimeout(timeout);
    timeout = window.setTimeout(() => fn(...args), wait);
  };
};

const sortFilterItems = (group) => {
  const items = group.querySelectorAll(".filter-item");
  if (!items.length) return;
  const sorted = Array.from(items).sort((a, b) => {
    const keyA = (a.dataset.sortKey || a.textContent || "").trim();
    const keyB = (b.dataset.sortKey || b.textContent || "").trim();
    return keyA.localeCompare(keyB, "de", { sensitivity: "base" });
  });
  sorted.forEach((item) => item.parentNode?.appendChild(item));
};

const updateExpandableFilter = (group) => {
  const items = group.querySelector(".filter-items");
  const btn = group.querySelector(".filter-toggle");
  const label = group.querySelector(".filter-label");
  if (!items || !btn) return;
    if (label) {
    group.style.setProperty(
      "--filter-label-width",
      `${label.getBoundingClientRect().width}px`
    );
  }

  const computedLineHeight = parseFloat(getComputedStyle(items).lineHeight);
  const fallbackLineHeight =
    items.firstElementChild?.getBoundingClientRect().height ||
    items.getBoundingClientRect().height ||
    0;
  const oneLine = Math.ceil(computedLineHeight || fallbackLineHeight);
  const collapsedHeight = oneLine * COLLAPSED_LINES;

  if (!oneLine) return;

  if (items.scrollHeight <= collapsedHeight + 2) {
    group.classList.remove("is-expanded");
    items.style.maxHeight = `${collapsedHeight}px`;
    btn.hidden = true;
    btn.setAttribute("aria-expanded", "false");
    return;
  }

  btn.hidden = false;
  const isExpanded = group.classList.contains("is-expanded");
  items.style.maxHeight = isExpanded
    ? `${items.scrollHeight}px`
    : `${collapsedHeight}px`;
  btn.textContent = isExpanded ? "Weniger anzeigen" : "Mehr anzeigen";
  btn.setAttribute("aria-expanded", isExpanded ? "true" : "false");

  if (!btn.dataset.toggleBound) {
    btn.dataset.toggleBound = "true";
    btn.addEventListener("click", () => {
      const expanded = group.classList.toggle("is-expanded");
      items.style.maxHeight = expanded
        ? `${items.scrollHeight}px`
        : `${collapsedHeight}px`;
      btn.textContent = expanded ? "Weniger anzeigen" : "Mehr anzeigen";
      btn.setAttribute("aria-expanded", expanded ? "true" : "false");
    });
  }
};

const initializeExpandableFilters = (root = document) => {
  root.querySelectorAll(".js-expandable-filter").forEach((group) => {
    sortFilterItems(group);
    updateExpandableFilter(group);
  });
  
  if (!resizeListenerBound) {
    resizeListenerBound = true;
    const refresh = debounce(() => initializeExpandableFilters(), 150);
    window.addEventListener("resize", refresh);
    window.addEventListener("orientationchange", refresh);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  initializeExpandableFilters();
    if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      initializeExpandableFilters();
    });
  }
});

document.addEventListener("shopify:section:load", (event) => {
  initializeExpandableFilters(event.target);
});

document.addEventListener("filter:update", () => {
  initializeExpandableFilters();
});
